import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class FaqList extends Component {
  state = {
    faqs: [],
    per_page: 20,
    page: 1,
    pagination: {
      total: 0,
      totalpage: 1,
      page: 1,
      limit: 20,
      nextpage: false,
      prevpage: false,
    },
    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
  };

  componentDidMount() {
    this.fetch(this.state.page, this.state.per_page);
  }

  fetch = (page = 1, limit = 20) => {
    if (init() !== "success") return;
    this.setState({ loading: true });
    axios
      .get(`${Constants.getUrls.getAllFaqs}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const rows = resp.data.data || [];
          const p = resp.data.pagination || {};
          this.setState({
            faqs: rows,
            pagination: {
              total: p.total || rows.length,
              totalpage: p.totalpage || Math.max(1, Math.ceil((p.total || rows.length) / limit)),
              page: p.page || page,
              limit: p.limit || limit,
              nextpage: !!p.nextpage,
              prevpage: !!p.prevpage,
            },
            page: p.page || page,
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            message: resp.data?.message || "Failed",
            loading: false,
            notiColor: "warning",
          });
        }
      })
      .catch(() =>
        this.setState({
          notification: true,
          message: "Something went wrong",
          loading: false,
          notiColor: "warning",
        })
      );
  };

  onEntriesChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => this.fetch(1, newLimit));
  };

  onPageChange = (newPage) => {
    this.fetch(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Delete this FAQ?")) return;
    axios
      .delete(Constants.deleteUrls.deleteFaq + id)
      .then((resp) => {
        this.setState(
          { notification: true, message: resp.data?.message || "Deleted", notiColor: "success" },
          () => {
            this.fetch(this.state.pagination.page, this.state.per_page);
          }
        );
        setTimeout(() => this.setState({ notification: false, message: "" }), 2000);
      })
      .catch((err) =>
        this.setState({
          notification: true,
          message: err?.response?.data?.message || "Delete failed",
          notiColor: "warning",
        })
      );
  };

  render() {
    const { faqs, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                FAQ Questions
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right">
              <Link to="/addfaq">
                <MDButton variant="contained" size="small" color="primary">
                  Create New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : faqs && faqs.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Question", accessor: "question" },
                      { Header: "Answer", accessor: "answer" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: faqs.map((faq, i) => ({
                      serial: (pagination.page - 1) * pagination.limit + (i + 1),
                      question: faq.question || "—",
                      answer: faq.answer.substring(0, 70) || "—",
                      action: (
                        <div style={{ display: "flex", gap: 10 }}>
                          <Tooltip title="Edit FAQ">
                            <Link to={{ pathname: `/updatefaq/${faq._id}`, state: { data: faq } }}>
                              <IconButton color="info" size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>
                          <Tooltip title="Delete FAQ">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(faq._id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalpage}
                  totalDocs={pagination.total}
                  onPageChange={this.onPageChange}
                  onEntriesPerPageChange={this.onEntriesChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Data Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="FAQ Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
